














































import {Component, Prop, Vue} from 'vue-property-decorator'
import {Product} from '../../models/Product'
import router from '../../router'
import ProductRowColumn2 from './ProductRowColumn2.vue'
import ProductRowGrid from './ProductRowGrid.vue'
import ProductRowList from './ProductRowList.vue'

@Component({
  components: {ProductRowColumn2, ProductRowList, ProductRowGrid},
})
export default class ProductRow extends Vue {
  @Prop() product: Product
  @Prop() currentIndex: number
  @Prop({default: 'list'}) display: string

  onClickAddCart(product: Product, delta = 1) {

  }
}

